import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

export default function EmailVerifyPage() {
  const { token } = useParams();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    axios.get(`${API}/api/auth/verify-email/${token}`)
      .then(r => {
        setStatus("success");
        setMessage(r.data.message);
        // Refresh the auth context so contact details unlock immediately
        checkAuth();
      })
      .catch(e => {
        setStatus("error");
        if (e.response?.status === 404) {
          setMessage("This verification link is invalid or has already been used. If your email is already verified, you can continue browsing the directory.");
        } else {
          setMessage(e.response?.data?.detail || "Verification failed");
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center pt-16 px-6">
      <div className="max-w-md w-full bg-[#0A0A0A] border border-[#D4AF37]/20 p-10 text-center">
        {status === "loading" && (
          <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto" />
        )}
        {status === "success" && (
          <>
            <CheckCircle size={44} className="text-emerald-400 mx-auto mb-4" />
            <h1 data-testid="email-verify-success" className="font-serif text-3xl text-white font-light mb-3">Email Verified</h1>
            <p className="text-[#A0A0A0] text-sm leading-relaxed mb-6">{message}</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={44} className="text-red-400 mx-auto mb-4" />
            <h1 data-testid="email-verify-error" className="font-serif text-3xl text-white font-light mb-3">Verification Failed</h1>
            <p className="text-[#A0A0A0] text-sm leading-relaxed mb-6">{message}</p>
          </>
        )}
        <Link
          to="/find-a-chef"
          data-testid="email-verify-cta"
          className="inline-block border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black px-8 py-3 text-sm tracking-widest uppercase font-medium transition-colors"
        >
          Browse Chefs
        </Link>
      </div>
    </div>
  );
}
